require('./sharedFiles.styles');
export const sharedFilesModule = angular
	.module('sharebase-app.sharedFiles', [
		'ui.router', 
		'sharebase'
	])
	.config([
		'$stateProvider', 
		'$urlRouterProvider',
		function ($stateProvider, $urlRouterProvider) {
			$stateProvider
				.state('content.shared.home', {
					url: '',
					data: {
						isTopLevel: true
					},
					views: {
						'sharedFilesContent': {
							template: function (params) { return '<sba-shared-content flex></sba-shared-content>';}
						},
						'homeDetails@content': {template: '<sba-empty-details flex />'}
					}
				})
				.state('content.shared.library', {
					url: '/library/:libraryID',
					resolve: {
						promiseObj: [
							'$stateParams',
							'sbaViewItemIndexDataStore',
							function ($stateParams, sbaViewItemIndexDataStore) {		
								//get index
								var path = '/shared-items/library/' + $stateParams.libraryID;
								//get index
								$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
								//clear index
								sbaViewItemIndexDataStore.remove(path);
							}]
					},
					views: {
						'sharedFilesContent': {
							template: function (params) {
								return '<sba-folder-view flex library-id="' + params.libraryID + '" item-index="' + params.itemIndex + '"></sba-folder-view>';
							}
						},
						'homeDetails@content': {template: '<sba-empty-details flex />'}
				},
				onExit: [
					'$location',
					'sbaViewItemIndexDataStore',
					function ($location, sbaViewItemIndexDataStore) {								
						var index = angular.element(document.querySelector('sba-folder-view')).attr('item-index');
						sbaViewItemIndexDataStore.add($location.path(), index);
					}]
			})
			.state('content.shared.folder', {
				url: '/folder/:folderID',
				resolve: {
					promiseObj: [
						'$stateParams',
						'sbaViewItemIndexDataStore',
						function ($stateParams, sbaViewItemIndexDataStore) {
								
							//get index
							var path = '/shared-items/folder/' + $stateParams.folderID;
							//get index
							$stateParams.itemIndex = sbaViewItemIndexDataStore.urlIndex(path);
							//clear index
							sbaViewItemIndexDataStore.remove(path);
							return;
						}]
				},
				views: {
					'sharedFilesContent': {
						template: function (params) {
							return '<sba-folder-view flex folder-id="' + params.folderID + '" item-index="' + params.itemIndex + '"></sba-folder-view>';
						}
					},
					'homeDetails@content':{
						template: function (params) {return '<sba-folder-details folder-id="' + params.folderID + '"></sba-folder-details>';}
					}
				},
				onExit: [
					'$location',
					'sbaFolderDataStore',
					'sbaViewItemIndexDataStore',
					function ($location,sbaFolderDataStore, sbaViewItemIndexDataStore) {							
						sbaFolderDataStore.clearStore();
						var index = angular.element(document.querySelector('sba-folder-view')).attr('item-index');
						sbaViewItemIndexDataStore.add($location.path(), index);
					}]
			})
			.state('content.shared.document', {
				url: '/document/:docID',
				views: {
					'sharedFilesContent': { template: function (params) { return '<sba-document-view flex document-id="' + params.docID + '"></sba-document-view>'; } },
					'homeDetails@content': {
						template: function (params) {
							return '<sba-document-details flex document-id="' + params.docID + '"></sba-document-details>';
						}
					}
				},
				onExit: [
					'sbaDocumentDataStore',
					function(sbaDocumentDataStore) {
						sbaDocumentDataStore.clearStore();
					}
				]
			});
	}])
	.directive('sbaSharedFiles', SharedFilesDirective);

const template = require('./sharedFiles.template');
function SharedFilesDirective() {
	return {
		restrict: 'E',
		controller: SharedFilesController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {},
		link: function (scope, element, attrs) {
		}
	};
}

function SharedFilesController(sbaViewItemIndexDataStore) {
}

SharedFilesController.$inject =  [
	'sbaViewItemIndexDataStore'
];


// WEBPACK FOOTER //
// ./src/sharebase-app/components/_sharedFiles/sharedFiles.ts